/*
 * AVISPLUS OPTIONS POSITION
 * This file moves the AvisPlus choices from above the product title
 * to just before the regular Shopify variant choices.
 *
 * To turn off this positioning later, remove the line that loads
 * avisplus-product-options-custom.js in layout/theme.liquid.
 * Leave Shopify's variant selector alone.
 */

(function () {
  var attempts = 0;
  var placementInterval = setInterval(function () {
    var options = document.querySelector('#avpoptions-container');
    var titleSeparator = document.querySelector(
      '.product-info__block-item--product-meta .card__separator'
    );

    if (options && titleSeparator) {
      titleSeparator.after(options);
      clearInterval(placementInterval);
      return;
    }

    attempts += 1;
    if (attempts >= 100) {
      clearInterval(placementInterval);
    }
  }, 100);
})();
